{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "최대 크기 {size}. {imageLimit}, {typeLimitText}, {typeLimitZip} 또는 {typeLimitSpreadsheet}만 허용됩니다. 여러 문서를 업로드하려면 먼저 zip으로 압축한 후 업로드하세요.",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "파일당 최대 크기 {size}. 최대 {count}개 파일. {image}, {text}, {zip} 또는 {spreadsheet}만 허용됩니다.",
    "oneImage": "이미지 1개",
    "sizeInMegabytes": "{size}MB",
    "uploadDocument": "문서 업로드",
    "uploadDocuments": "문서 업로드"
  }
}
